/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';

var RedoIcon = createIcon({
  name: 'RedoIcon',
  height: 512,
  width: 512,
  svgPath: 'M500.333 0h-47.411c-6.853 0-12.314 5.729-11.986 12.574l3.966 82.759C399.416 41.899 331.672 8 256.001 8 119.34 8 7.899 119.526 8 256.187 8.101 393.068 119.096 504 256 504c63.926 0 122.202-24.187 166.178-63.908 5.113-4.618 5.354-12.561.482-17.433l-33.971-33.971c-4.466-4.466-11.64-4.717-16.38-.543C341.308 415.448 300.606 432 256 432c-97.267 0-176-78.716-176-176 0-97.267 78.716-176 176-176 60.892 0 114.506 30.858 146.099 77.8l-101.525-4.865c-6.845-.328-12.574 5.133-12.574 11.986v47.411c0 6.627 5.373 12 12 12h200.333c6.627 0 12-5.373 12-12V12c0-6.627-5.373-12-12-12z',
  yOffset: '',
  xOffset: '',
  transform: ''
});

export default RedoIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-icons/dist/esm/icons/redo-icon.js
// module id = 878
// module chunks = 0